import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import SignatureCanvas from 'react-signature-canvas'
import ClearIcon from '@material-ui/icons/Clear'


const styles = (theme) => {
    return ({
        sigCanvas: {
            border: '1px solid black',
        },
        container: {
            position: 'relative'
        },
        controls: {
            position: 'absolute',
            margin: '10px',
            right: 0,
            top: 0,
            color: theme.palette.secondary.main
        }
    })
};

class SignatureField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            signatureWidth: 550,
            signatureHeight: 150
        }

        this.signature_ref = React.createRef();
        this.signature_canvas_ref = React.createRef();
    }

    // handleChange = (e) => {
    //     this.setState({
    //         data: {
    //             ...this.state.data,
    //             [e.target.name]: e.target.value
    //         }
    //     })
    // }

    handleSignatureChange = (e) => {
        // this.setState({
        //     ...this.state,
        //     data: {
        //         ...this.state.data,
        //         [e.current.props.name]: e.current.toDataURL()//.replace('data:image/png;base64,', '')
        //     }
        // })
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: e.current.toDataURL()
                }
            })
        }
    }

    handleClearClick = () => {
        if (this.signature_canvas_ref.current && !this.props.disabled) {
            this.signature_canvas_ref.current.clear()
        }
    }

    componentDidMount() {
        setTimeout(() => {
            if(this.props.disabled)
            {
                this.signature_canvas_ref.current.off()
            }

            const width = this.signature_ref.current.offsetWidth - 2
            this.setState({
                signatureWidth: width,
                signatureHeight: width * (this.props.ratio ? this.props.ratio : 0.2727272727272727),
            })
        })
    }

    render() {
        const { classes } = this.props;

        // esto es pa que despues de cada render, actualice la imagen con la escala q es
        setTimeout(() => {
            if (this.signature_canvas_ref.current) {
                this.signature_canvas_ref.current.clear()

                var image = new Image();
                image.src = this.props.value
                image.onload = () => {
                    this.signature_canvas_ref.current.getCanvas().getContext('2d').drawImage(image, 0, 0, this.signature_canvas_ref.current.getCanvas().width, this.signature_canvas_ref.current.getCanvas().height)
                }
            }
            // this.signature_canvas_ref.current.fromDataURL(this.props.value)
        })

        return (
            <React.Fragment>
                <div ref={this.signature_ref} className={classes.container}>
                    <SignatureCanvas
                        ref={this.signature_canvas_ref}
                        onEnd={() => this.handleSignatureChange(this.signature_canvas_ref)}
                        penColor='black'
                        canvasProps={{ className: classes.sigCanvas, width: this.state.signatureWidth, height: this.state.signatureHeight }} />
                    <div className={classes.controls} onClick={this.handleClearClick}><ClearIcon/></div>
                </div>
            </React.Fragment>
        )
    }
}

export default withStyles(styles)(SignatureField);